module.exports = __webpack_public_path__ + "static/media/ICON-BUSINESS_SERVICES.86121608.svg";